// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__uRTwz","default-layout":"DefaultLayout_default-layout__lje80","wrap":"DefaultLayout_wrap__zb-8J","wrap-child":"DefaultLayout_wrap-child__Ch4T5"};